// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_r2-0";
export var animationContainer = "_r2-1";
export var itemPrice = "_r2-a";
export var itemizedContent = "_r2-9";
export var itemizedHeader = "_r2-7";
export var itemizedRow = "_r2-8";
export var itemizedSection = "_r2-6";
export var modalContent = "_r2-2";
export var orderName = "_r2-3";
export var refundOption = "_r2-4";
export var refundOptionsContainer = "_r2-5";
export var shippingLabel = "_r2-b";
export var totalRow = "_r2-c";